import React, { useState } from 'react'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { GrupoDetalheUtilizacaoServico } from '../../../../interfaces/entities/UtilizacaoServicos/GrupoDetalheUtilizacaoServico'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Collapse, Divider } from '@mui/material';
import { formatISOFormatToDate } from '../../../../utils/DateFormat';
import { OcultarCpfRegex } from '../../../../utils/OcultarCpfRegex';

const GrupoDetalheUtilizacaoData: React.FC<{ GrupoDetalhe: GrupoDetalheUtilizacaoServico | null, Type: string }> = ({ GrupoDetalhe, Type }) => {
  const [open, setOpen] = useState<boolean>(false);
  const isConsulta = () => Type === 'Consulta'

  const { fontSizeStyleAccessibility } = useAccessibility();

  return (
    <div className="grupo-detalhe-holder">
      <div className="">
        <span style={fontSizeStyleAccessibility} className="detalhes-descricao-title">{isConsulta() ? 'Prestador:' : 'Descrição:'}</span>
        <span style={fontSizeStyleAccessibility} className="registration-data-value">{isConsulta() ? GrupoDetalhe?.prestador : GrupoDetalhe?.descricao}</span>
      </div>
      <button className="utilizacao-expand-button" onClick={() => setOpen(!open)}>
        <u>Mais informações</u>&nbsp;&nbsp;<FontAwesomeIcon width="10px" icon={open ? faChevronUp : faChevronDown} />
      </button>
      <Collapse in={open}>
        <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />
        <div className="utilizacao-detalhes-card">
          <div>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-key">{isConsulta() ? 'Especialidade' : 'Prestador'}</span>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-value">{isConsulta() ? GrupoDetalhe?.descricao : GrupoDetalhe?.prestador}</span>
          </div>
          <div>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-key">CPF/CNPJ</span>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-value">
              {(!!GrupoDetalhe?.cpf_cnpj?.length && GrupoDetalhe.cpf_cnpj.replace(/[^A-Za-z0-9]/g, '').length <= 11) ? OcultarCpfRegex(GrupoDetalhe?.cpf_cnpj || ''): GrupoDetalhe?.cpf_cnpj}
              </span>
          </div>
          <div>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-key">Data do atendimento</span>
            <span style={fontSizeStyleAccessibility} className="utilizacao-detalhes-value">{formatISOFormatToDate(GrupoDetalhe?.dtAtend || '')}</span>
          </div>
        </div>
      </Collapse> 
    </div>
  )
}

export default GrupoDetalheUtilizacaoData